module.exports = __webpack_public_path__ + "static/img/弹窗.2fb6d53.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/market/market110/弹窗.png
// module id = ln2e
// module chunks = 1